import { Fragment, useState } from 'react';
import { Portal } from 'react-portal';

import { CompareBar } from './compare-bar/CompareBar';
import { CompareModal } from './compare-modal/CompareModal';

import { useProductContext, useCompareContext } from '../../context/PlpContext';
import { enrichCompareProductData } from '../../utils/compare/enrichCompareProductData';
import {
  CompareProduct,
  EnrichedCompareProduct,
} from '../../utils/types/types';

export const Compare = () => {
  const {
    data: compareData,
    products,
  }: { data: CompareProduct[]; products: string[] } = useCompareContext();

  const { products: productData } = useProductContext();

  let enrichedProducts: EnrichedCompareProduct[] = [];

  if (compareData) {
    enrichedProducts = enrichCompareProductData(compareData, productData);
  }

  const [showCompareBar, setShowCompareBar] = useState(false);

  if (products.length > 0 && !showCompareBar) {
    setShowCompareBar(true);
  }

  function removeCompareBar() {
    setShowCompareBar(false);
  }

  return (
    <Fragment>
      {showCompareBar && (
        <Portal>
          <CompareBar removeCompareBar={removeCompareBar} />
        </Portal>
      )}

      {products.length > 0 && <CompareModal products={enrichedProducts} />}
    </Fragment>
  );
};

export default Compare;
